export default "__VITE_ASSET__b9c7170c__"